import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDeviceDetectionByIdSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type GetDeviceDetectionByIdSubscription = { __typename?: 'subscription_root', device_detection_jobs_by_pk?: { __typename?: 'device_detection_jobs', id: any, workspace_id?: any | null, status: string, input_files?: any | null, ai_response?: any | null, detected_devices?: any | null, detected_installed_products?: any | null, products_grouped_by_type?: any | null, handover_id?: any | null, created_at?: any | null, updated_at: any, property_id: any, organization_id?: any | null, created_by_user_id?: string | null, property: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, photo_link?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null }, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null, author?: { __typename?: 'users', first_name: string, last_name: string, email: string } | null } | null };


export const GetDeviceDetectionByIdDocument = gql`
    subscription getDeviceDetectionById($id: uuid!) {
  device_detection_jobs_by_pk(id: $id) {
    id
    workspace_id
    status
    input_files
    ai_response
    detected_devices
    detected_installed_products
    products_grouped_by_type
    handover_id
    created_at
    updated_at
    property_id
    property {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      photo_link
    }
    organization_id
    organization {
      id
      name
      type
      organizationImageURL
    }
    created_by_user_id
    author {
      first_name
      last_name
      email
    }
  }
}
    `;

/**
 * __useGetDeviceDetectionByIdSubscription__
 *
 * To run a query within a React component, call `useGetDeviceDetectionByIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceDetectionByIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceDetectionByIdSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDeviceDetectionByIdSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetDeviceDetectionByIdSubscription, GetDeviceDetectionByIdSubscriptionVariables> & ({ variables: GetDeviceDetectionByIdSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetDeviceDetectionByIdSubscription, GetDeviceDetectionByIdSubscriptionVariables>(GetDeviceDetectionByIdDocument, options);
      }
export type GetDeviceDetectionByIdSubscriptionHookResult = ReturnType<typeof useGetDeviceDetectionByIdSubscription>;
export type GetDeviceDetectionByIdSubscriptionResult = Apollo.SubscriptionResult<GetDeviceDetectionByIdSubscription>;